import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    DataSelect,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffOrderTemplatesEdit(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formShopId, setFormShopId] = useState(null);
    const [formShopIdOptions, setFormShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-order-templates-edit/select-data/shop-id').then(
            (response) => {
                setFormShopIdOptions(response.data);
            }
        );
    }, []);
    const [formTitle, setFormTitle] = useState(null);
    const [formWeight, setFormWeight] = useState(null);
    const [formPrice, setFormPrice] = useState(null);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-order-templates-edit/save-data', {
            id: allProps['id'],
            shop_id: formShopId,
            title: formTitle,
            weight: formWeight,
            price: formPrice,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-order-templates-edit/form-data', {
            id: allProps['id'],
        }).then((response) => {
            setFormShopId(response.data.shop_id);
            setFormTitle(response.data.title);
            setFormWeight(response.data.weight);
            setFormPrice(response.data.price);
        });
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>ویرایش</Title>
                <Grid>
                    <GridColumn width={12}>
                        <DataSelect
                            label={'فروشگاه'}
                            options={formShopIdOptions}
                            value={formShopId}
                            onChange={setFormShopId}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'عنوان'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'وزن'} value={formWeight} onChange={setFormWeight} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'قیمت'} value={formPrice} onChange={setFormPrice} />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
